import {makeAutoObservable} from "mobx";

import * as Api from 'api/api'

class HomeGuessYouLikeStore {

    loading = true
    list = []

    async fetchData() {
        this.list = await Api.fetchGuessYouLike()
        this.loading = false
    }

    constructor() {
        makeAutoObservable(this)
    }
}

export default HomeGuessYouLikeStore